<template>
  <div class="privacy-policy">
    <Agreement
      v-if="showStatement"
      isConsent
      ref="agreement"
      :class="[!companyId && 'no-policy']"
      :policyInfo="policyInfo"
      :showSystemPolicy="true"
      :isAgreeSystemPolicy="isAgreeSystemPolicy"
    >
      <template #btnGroup>
        <el-button class="cancel-btn footer-button" @click="handleCancel">{{ cancelBtn }}</el-button>
        <el-popover
          :popper-class="`custom-consent-confirm-popover ${!isPc && 'mobile'}`"
          trigger="manual"
          v-model="showPopConfirm"
        >
          <div class="title">{{ confirmTip }}</div>
          <div class="btn">
            <el-button type="text" @click="handleCancelPop" size="mini">{{ $t('common.btn.cancel') }}</el-button>
            <el-button type="primary" @click="handleConfirmPop" size="mini">{{ $t('common.btn.confirm') }}</el-button>
          </div>
          <template #reference>
            <el-button class="confirm-btn footer-button" @click="handleSubmit">{{ submitBtn }}</el-button>
          </template>
        </el-popover>
      </template>
    </Agreement>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import { deviceType } from '@/utils/common'
import _ from 'lodash'
import Agreement from '@/components/agreement/agreementContent.vue'

export default {
  components: {
    Agreement
  },
  props: {
    cancelLabelI18nKey: {
      type: String
    },
    submitLabelI18nKey: {
      type: String
    }
  },
  data () {
    return {
      htmlContent: null,
      showStatement: false,
      jobCompanyId: null,
      isAgreeSystemPolicy: false,
      policyInfo: {},
      showPopConfirm: false,
      confirmTip: null
    }
  },
  computed: {
    isPc () {
      return deviceType.isPc
    },
    companyId () {
      return this.$route.query.company_id
    },
    backUrl () {
      return this.$route.query.back_url
    },
    hasColorCustomization () {
      return this.policyInfo.company_has_color_customization
    },
    customColor () {
      return this.policyInfo.company_custom_color ? this.policyInfo.company_custom_color : '#fff'
    },
    cancelBtn () {
      if (this.cancelLabelI18nKey) {
        return this.$t(this.cancelLabelI18nKey)
      }
      if (this.policyInfo.popup) {
        const footerBtn = _.find(this.policyInfo.popup.footer, footerBtn => footerBtn.type === 'BUTTON_CANCEL')
        if (footerBtn) {
          addI18nProperty(footerBtn, 'i18nCancelBtn', 'content_cn', 'content_en')
          return footerBtn.i18nCancelBtn
        }
      }
      return this.$t('common.btn.cancel')
    },
    submitBtn () {
      if (this.submitLabelI18nKey) {
        return this.$t(this.submitLabelI18nKey)
      }
      if (this.policyInfo.popup) {
        const footerBtn = _.find(this.policyInfo.popup.footer, footerBtn => footerBtn.type === 'BUTTON_SAVE')
        if (footerBtn) {
          addI18nProperty(footerBtn, 'i18nCancelBtn', 'content_cn', 'content_en')
          return footerBtn.i18nCancelBtn
        }
      }
      return this.$t('common.btn.save')
    }
  },
  created () {
    this.initPageData()
  },
  methods: {
    ...mapActions('personal', ['getConsentAgreementStatus', 'updateConsentAgreementStatus']),
    async initPageData () {
      this.showStatement = false
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getConsentAgreementStatus({
          company_id: this.companyId || null
        })
        if (resp) {
          this.jobCompanyId = resp.company_id
          this.isAgreeSystemPolicy = resp.is_agreed_system_policy
          this.policyInfo = resp.policy_info || {}
          addI18nProperty(this.policyInfo, 'companyName', 'company_cn_name', 'company_en_name')
          if (resp.is_company_policy_update) {
            this.$message.warning(this.$t('admin.company.agreement.message.consentUpdated'))
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.showStatement = true
      }
    },
    async handleSubmit () {
      const agreementRef = this.$refs.agreement
      if (!agreementRef.agreeSystemPolicy) {
        // 系统级没同意，则提示注销信息
        this.showPopConfirm = true
        this.confirmTip = this.$t('common.message.logoff')
        return
      }
      _.forEach(agreementRef.bodyContent, (policy) => {
        if (!policy.is_required) {
          return
        }
        const agree = agreementRef.formModel['policy_' + policy.id]
        if (!agree) {
          // 未同意公司required协议，提示revoke all
          this.showPopConfirm = true
          this.confirmTip = this.$t('common.message.revokeAllApplication')
          return false
        }
      })
      if (!this.showPopConfirm) {
        this.updateConsentInfo()
      }
    },
    handleCancelPop () {
      this.showPopConfirm = false
    },
    handleConfirmPop () {
      this.updateConsentInfo()
      this.showPopConfirm = false
    },
    handleCancel () {
      this.$router.go(-1)
    },
    async updateConsentInfo () {
      const agreementRef = this.$refs.agreement
      this.$eventBus.$emit('showLoading', true)
      try {
        const policyItemIds = []
        for (const policy in agreementRef.formModel) {
          if (agreementRef.formModel[policy]) {
            policyItemIds.push(policy.substring(7))
          }
        }
        const agreementInfo = {
          company_id: this.companyId,
          is_agreed_system_policy: agreementRef.agreeSystemPolicy,
          agree_item_ids: policyItemIds
        }

        await this.updateConsentAgreementStatus(agreementInfo)
        if (!agreementRef.agreeSystemPolicy) {
          this.$router.push('/passport/recruiter/login')
        } else {
          this.backUrl ? window.location.href = decodeURIComponent(this.backUrl) : this.$router.go(-1)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.privacy-policy {
  height: 100vh;
  height: 100dvh;
  background: #000;

  .no-policy {
    ::v-deep {
      .company-policy-popup-content-container {
        .container-body {
          min-height: 40px;
        }
      }
    }
  }

  .footer-button {
    font-size: 14px;
    border: 0;
    cursor: pointer;
    line-height: 14px;
    padding: 10px 30px;
    background: var(--custom-color, #0096cc);
    color: #fff;

    &:first-child {
      margin-left: 0;
      background: #a9a9a9;
      color: #fff;
      border: 1px solid #a9a9a9;
    }

    &:last-child {
      background: var(--custom-color, #0096cc);
      color: #fff;
      border: 1px solid var(--custom-color, #0096cc);
    }
  }

  .cancel-btn {
    font-size: 14px;
    border: 0;
    cursor: pointer;
    line-height: 14px;
    padding: 10px 30px;
    background: #a9a9a9;
    color: #fff;
    border: 1px solid #a9a9a9;
  }

  .resume-applicant-mobile {
    .footer-button {
      width: 120px;
      height: 30px;
      border-radius: 15px;
      margin: 0;
      padding: 0;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;

      &:first-child {
        margin-right: auto;
        background: #a9a9a9;
        color: #fff;
        border: 1px solid #a9a9a9;
      }

      &:last-child {
        margin-left: auto;
        background: #fff;
        color: var(--custom-color, #0096cc);
        border: 1px solid var(--custom-color, #0096cc);
      }
    }

    .cancel-btn {
      width: 120px;
      height: 30px;
      border-radius: 15px;
      margin: 0;
      padding: 0;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      background: #a9a9a9;
      color: #fff;
      border: 1px solid #a9a9a9;
    }
  }
}

.custom-consent-confirm-popover {
  .title {
    width: 100%;
    margin: 12px 0;
    word-break: break-word;
  }

  .btn {
    text-align: right;
  }
}
</style>

<style lang="scss">
.custom-consent-confirm-popover {
  &.mobile {
    width: 70%;
  }
}
</style>
